<template>
  <div>
    <a @click="isActive = !isActive">Click here to see a description of roles</a>
    <b-notification v-model="isActive" aria-close-label="Close notification">
      <div>
        <div><b>ACC Full access</b> - paid Carbon Calculator users</div>
        <div><b>ACC Presale access</b> - unpaid Carbon Calculator users</div>
        <div><b>Admin</b> - administrator for site (access to everything)</div>
        <div><b>AWG Member</b> - member access for both sites</div>
        <div><b>AWG Member - ACC only</b> - member access for Carbon Calculator</div>
        <div><b>AWG Member - CTC only</b> - member access for CTC Compliance Index</div>
        <div><b>CTC Country Respondent</b> - users that can answer questionnaires for a country</div>
        <div><b>CTC Country Viewer</b> - users can access to all materials relating to a country</div>
        <div><b>CTC Enhanced</b> - access equal to an AWG member</div>
        <div><b>CTC Standard</b> - access to all materials except complimentary CFT, annotations and data-graphing</div>
      </div>
    </b-notification>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        isActive: false
      }
    }
  }
</script>

<style></style>
